import { useIsLanding } from 'modules/promoLandings/hooks/useIsLanding';
import { useIsRegModalFlow } from 'modules/promoLandings/hooks/useIsRegModalFlow';
import type { TAuthFormPlace } from '../events/authEvents';

// Where the auth form the player is looking at lives, as the analytics spec
// names it. Both signals mean a landing: the route and the affiliate query.
export const useAuthFormPlace = (): TAuthFormPlace => {
  const { isLanding } = useIsLanding();
  const isRegModalFlow = useIsRegModalFlow();

  return isLanding || isRegModalFlow ? 'modal-landing' : 'modal-lobby';
};
